<template>
  <div>
    <b-row v-if="loading" class="d-flex p-4 align-items-center justify-content-center">
      <loading-spinner class="my-5" />
    </b-row>
    <b-row v-else-if="state === 'TYPE_SELECTOR' && !loading" class="mt-3 mb-4">
      <b-col style="border-right: 1px solid #e2e8f0;">
        <option-block
          icon="link"
          customIcon="fa-building"
          description="Add a content link. Choose this option if you want to drive viewers to your own content or website. - Take candidates to content source - Direct audience to your website."
          buttonText="Add Content (standalone)"
          @click="addLink"
        />
      </b-col>
      <b-col>
        <option-block
          icon="pencil-ruler"
          customIcon="rl-logo"
          description="Host your content on Real Links. Choose this option if you want to display related jobs under your content."
          buttonText="Add Content Linked to Jobs"
          @click="addContent"
        />
      </b-col>
    </b-row>
    <transition name="fade">
      <div
        v-if="state === 'ADD_LINK' && !loading"
        class="mt-3"
      >
        <add-link-form-v2
          :value="form"
          :isEdit="!!value"
          @input="saveForm"
          :tagOptions="tagOptions"
          v-if="hasContentSharesV2Enabled"
        />
        <add-link-form
          :value="form"
          :isEdit="!!value"
          @input="saveForm"
          v-else
        />
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="state === 'ADD_CONTENT' && !loading"
        class="mt-3"
      >
        <add-content-form-v2
          :value="form"
          :isEdit="!!value"
          @input="saveForm"
          :tagOptions="tagOptions"
          v-if="hasContentSharesV2Enabled"
        />
        <add-content-form
          :value="form"
          :isEdit="!!value"
          @input="saveForm"
          v-else
        />
      </div>
    </transition>
  </div>
</template>

<script>
import enumsMixin from '@/mixins/enums';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import formValidationMixin from '@src/mixins/formValidation';
import RichTextField, { RichTextContent } from '@/components/RichTextField';
import OptionBlock from '@/components/content-share/content-share-editor/OptionBlock';
import AddLinkForm from '@/components/content-share/content-share-editor/AddLinkForm';
import AddLinkFormV2 from '@/components/content-share/content-share-editor/AddLinkFormV2';
import AddContentForm from '@/components/content-share/content-share-editor/AddContentForm';
import AddContentFormV2 from '@/components/content-share/content-share-editor/AddContentFormV2';
import ContentShareCreateMutation from '@/graphql/mutations/ContentShareCreate.gql';
import ContentShareUpdateMutation from '@/graphql/mutations/ContentShareUpdate.gql';
import { mapPreferences } from '@/mixins/root';

export default {
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    tagOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingSpinner,
    RichTextField,
    RichTextContent,
    OptionBlock,
    AddLinkForm,
    AddContentForm,
    AddLinkFormV2,
    AddContentFormV2,
  },
  mixins: [
    enumsMixin,
    formValidationMixin,
  ],
  data: () => ({
    form: {},
    state: 'TYPE_SELECTOR'
  }),
  computed: {
    ...mapPreferences([ 'featuresEnabled' ]),
    hasContentSharesV2Enabled() {
      return (this.featuresEnabled || []).includes('content-share-v2');
    },
  },
  watch: {
    value: {
      handler(value) {
        console.log('value', value);
        if (value) {
          const { id, ...form } = value;
          this.form = { ...form };
        }
        if (value && !value.content) {
          this.state = 'ADD_LINK';
        } else if (value && value.content) {
          this.state = 'ADD_CONTENT';
        } else {
          this.state = 'TYPE_SELECTOR';
        }
        console.log('VALUE', value);
      },
      immediate: true,
    },
  },
  methods: {
    addLink() {
      this.state = 'ADD_LINK';
    },
    addContent() {
      this.state = 'ADD_CONTENT';
    },
    async saveForm(form) {
      this.form = form;
      try {
        if (!this.value || !this.value.id) {
          const { data } = await this.$apollo.mutate({
            mutation: ContentShareCreateMutation,
            variables: { create: form },
          });

          if (data && data.createContentShare && data.createContentShare.id) {
            const { title } = data.createContentShare;
            this.$notification({
              title: 'Content created',
              message: `Content with title '${title}' is created successfully`,
              variant: 'success',
            });
            this.$emit('created', data.createContentShare);
          } else {
            throw new Error('Failed to create content');
          }
        } else {
          const { data } = await this.$apollo.mutate({
            mutation: ContentShareUpdateMutation,
            variables: {
              contentShareID: this.value.id,
              update: form
            },
          });

          if (data && data.updateContentShare && data.updateContentShare.id) {
            const { title } = data.updateContentShare;
            this.$notification({
              title: 'Content updated',
              message: `Content with title '${title}' is updated successfully`,
              variant: 'success',
            });
            this.$emit('updated', data.updateContentShare);
          } else {
            throw new Error('Failed to update content');
          }
        }

      } catch (err) {
        console.error(err);
        this.selectedUserErr = err;
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/ContentShareEditor.vue